/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum DaysRange {
    _0_30_days = '0-30 days',
    _31_60_days = '31-60 days',
    _61_90_days = '61-90 days',
    _91_365_days = '91-365 days',
    _365_days = '> 365 days',
    Unknown = 'Unknown'
}
